import { Card, Col, Row, Table } from "react-bootstrap";

export const PeopleControl = ({ hotel }) => {

  return (
    <>
      <Row>
        <Col sm={12} className="col-12">
          <Card>
            <Card.Header>
              <h3 className="card-title mb-0">Huespedes</h3>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table className="table text-nowrap text-md-nowrap mg-b-0">
                  <tbody>
                    {
                      hotel.adults > 0 &&
                      <tr >
                        <td>Adultos</td>
                        <td>{hotel.adults}</td>
                      </tr>
                    }
                    {
                      hotel.juniors > 0 &&
                      <tr >
                        <td>Juniors</td>
                        <td>{hotel.juniors}</td>
                      </tr>
                    }
                    {
                      hotel.minors > 0 &&
                      <tr >
                        <td>Menores</td>
                        <td>{hotel.minors}</td>
                      </tr>
                    }
                    {
                      hotel.infants > 0 &&
                      <tr >
                        <td>Infantes</td>
                        <td>{hotel.infants}</td>
                      </tr>
                    }
                    <tr style={{ fontWeight: "bold" }}>
                      <td>Total</td>
                      <td>{hotel.adults + hotel.juniors + hotel.minors + hotel.infants}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}
